import styled from "styled-components";

export const Container = styled.div`
  margin-top: -15px;
  margin-bottom: 10px;
  padding: 6px;
  border: 2px solid #feb3b3;
  border-radius: 5px;
  background-color: #fff5f5;

  & p {
    font-size: 16px;
  }
`;

export const ContainerNoError = styled.div`
  margin-top: -15px;
  margin-bottom: 10px;
  height: 35px;
`;
